/**
 * "Perfect companions" (SPEC-003 D-5).
 *
 * No content pack names a companion, so this is derived. A companion is a plant
 * that wants the same conditions — the same sun and roughly the same water — and
 * preferably a different habit, because four more perennials is a shelf, not a
 * planting scheme.
 */

export const COMPANION_COUNT = 4;

/**
 * Lower is closer. Sun and water are the two properties that decide whether two
 * plants can share a bed at all; a same-category candidate is pushed behind an
 * otherwise equal one from a different category, which is what gives the rail its
 * mix of shrub, perennial and grass.
 */
export function companionDistance(plant, candidate) {
    const gap = (property) => Math.abs(
        plant.properties[property].score - candidate.properties[property].score,
    );

    return gap('sun') + gap('water') + (candidate.category === plant.category ? 1 : 0);
}

export function selectCompanions(plants, plant, { limit = COMPANION_COUNT, languageCode = 'en' } = {}) {
    if (!plant) {
        return [];
    }

    const name = (candidate) => String(candidate.prose?.commonName ?? candidate.id);

    return plants
        .filter((candidate) => candidate.id !== plant.id)
        .map((candidate) => ({ candidate, distance: companionDistance(plant, candidate) }))
        // Ties break on the name the user reads, so the rail does not reshuffle
        // itself between builds when the catalogue gains a plant.
        .sort((left, right) => (
            left.distance - right.distance
            || name(left.candidate).localeCompare(name(right.candidate), languageCode)
        ))
        .slice(0, limit)
        .map((ranked) => ranked.candidate);
}
